export const dataFirstViewPro = {
  description:
    'Voici votre besoin principal dans votre vie professionnelle. La satisfaction de vos besoins est à la source de votre bien-être et de votre motivation. Il est important que votre métier, vos conditions de travail et de rémunération, ainsi que vos relations professionnelles contribuent pleinement à satisfaire ce besoin.',
};
